/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'th',
  Pagination: {
    items_per_page: '/ หน้า',
    jump_to: 'ไปยัง',
    jump_to_confirm: 'ยืนยัน',
    page: '',
    prev_page: 'หน้าก่อนหน้า',
    next_page: 'หน้าถัดไป',
    prev_5: 'ย้อนกลับ 5 หน้า',
    next_5: 'ถัดไป 5 หน้า',
    prev_3: 'ย้อนกลับ 3 หน้า',
    next_3: 'ถัดไป 3 หน้า'
  },
  DatePicker: {
    lang: {
      placeholder: 'เลือกวันที่',
      rangePlaceholder: ['วันเริ่มต้น', 'วันสิ้นสุด'],
      locale: 'th_TH',
      today: 'วันนี้',
      now: 'ตอนนี้',
      backToToday: 'กลับไปยังวันนี้',
      ok: 'ตกลง',
      clear: 'ลบล้าง',
      month: 'เดือน',
      year: 'ปี',
      timeSelect: 'เลือกเวลา',
      dateSelect: 'เลือกวัน',
      monthSelect: 'เลือกเดือน',
      yearSelect: 'เลือกปี',
      decadeSelect: 'เลือกทศวรรษ',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'เดือนก่อนหน้า (PageUp)',
      nextMonth: 'เดือนถัดไป (PageDown)',
      previousYear: 'ปีก่อนหน้า (Control + left)',
      nextYear: 'ปีถัดไป (Control + right)',
      previousDecade: 'ทศวรรษก่อนหน้า',
      nextDecade: 'ทศวรรษถัดไป',
      previousCentury: 'ศตวรรษก่อนหน้า',
      nextCentury: 'ศตวรรษถัดไป'
    },
    timePickerLocale: {
      placeholder: 'เลือกเวลา'
    }
  },
  TimePicker: {
    placeholder: 'เลือกเวลา'
  },
  Calendar: {
    lang: {
      placeholder: 'เลือกวันที่',
      rangePlaceholder: ['วันเริ่มต้น', 'วันสิ้นสุด'],
      locale: 'th_TH',
      today: 'วันนี้',
      now: 'ตอนนี้',
      backToToday: 'กลับไปยังวันนี้',
      ok: 'ตกลง',
      clear: 'ลบล้าง',
      month: 'เดือน',
      year: 'ปี',
      timeSelect: 'เลือกเวลา',
      dateSelect: 'เลือกวัน',
      monthSelect: 'เลือกเดือน',
      yearSelect: 'เลือกปี',
      decadeSelect: 'เลือกทศวรรษ',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'เดือนก่อนหน้า (PageUp)',
      nextMonth: 'เดือนถัดไป (PageDown)',
      previousYear: 'ปีก่อนหน้า (Control + left)',
      nextYear: 'ปีถัดไป (Control + right)',
      previousDecade: 'ทศวรรษก่อนหน้า',
      nextDecade: 'ทศวรรษถัดไป',
      previousCentury: 'ศตวรรษก่อนหน้า',
      nextCentury: 'ศตวรรษถัดไป'
    },
    timePickerLocale: {
      placeholder: 'เลือกเวลา'
    }
  },
  global: {
    placeholder: 'กรุณาเลือก'
  },
  Table: {
    filterTitle: 'ตัวกรอง',
    filterConfirm: 'ยืนยัน',
    filterReset: 'รีเซ็ต',
    selectAll: 'เลือกทั้งหมดในหน้านี้',
    selectInvert: 'เลือกสถานะตรงกันข้าม',
    sortTitle: 'เรียง',
    expand: 'แสดงแถวข้อมูล',
    collapse: 'ย่อแถวข้อมูล'
  },
  Modal: {
    okText: 'ตกลง',
    cancelText: 'ยกเลิก',
    justOkText: 'ตกลง'
  },
  Popconfirm: {
    okText: 'ตกลง',
    cancelText: 'ยกเลิก'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'ค้นหา',
    itemUnit: 'ชิ้น',
    itemsUnit: 'ชิ้น'
  },
  Upload: {
    uploading: 'กำลังอัปโหลด...',
    removeFile: 'ลบไฟล์',
    uploadError: 'เกิดข้อผิดพลาดในการอัปโหลด',
    previewFile: 'ดูตัวอย่างไฟล์',
    downloadFile: 'ดาวน์โหลดไฟล์'
  },
  Empty: {
    description: 'ไม่มีข้อมูล'
  },
  Icon: {
    icon: 'ไอคอน'
  },
  Text: {
    edit: 'แก้ไข',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    expand: 'ขยาย'
  },
  PageHeader: {
    back: 'ย้อนกลับ'
  }
};
